enum ROUTES {
  ROOT = "/",
  WORKERS_LIST = "workers-list",
  CLIENTS_LIST = "client-list",
  MAP = "map",
  MATERIAL_LIST = "material-list",
  COMPANIES_LIST = "companies-list",
  INSPECTION_CHECKLIST = "inspection-checklist",
  PRICES_CONFIG = "prices-config",
  SERVICE_ORDERS = "service-orders",
  INVOICE = "invoice",
}

export default ROUTES;
